<template>
    <div class="login">
        <div class="d-flex justify-content-center align-items-center flex-column">
            <h2 class="text-center fw-600 text-white mb-4 mx-5">Welcome to {{appname}}</h2>

            <div class="form-group w-100">
                <input style="font-weight: 700 !important;letter-spacing: 0.3px; font-size: 14px;" type="text" class="form-control custom-input text-uppercase" v-model="data.employee_id" @keyup.enter="trigger" placeholder="Employee ID">
            </div>
            <div class="form-group w-100">
                <input style="font-weight: 700 !important;letter-spacing: 0.3px; font-size: 14px;" type="password" class="form-control custom-input" v-model="data.password" @keyup.enter="trigger" placeholder="Password">
            </div>
            <div class="form-group w-100">
                <jl-button class="btn btn-primary w-100 fw-600" :eventClick="login" ref="button">Login</jl-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            appname: process.env.VUE_APP_APPNAME,
            data: {
                employee_id: '',
                password: ''
            }
        }
    },
    methods: {
        async login(e) {
            await this.$axios.post('/auth', this.$qs.stringify(this.data))
                    .then((res) => {
                        if(res.status == 200) {
                            localStorage.setItem('versatechvex_data', JSON.stringify(res.data));
                            window.location.reload(true);
                        }
                        else {
                            this.$jlalert.show(res.data);
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });

            this.$jlbutton.unload(e)
        },
        trigger() {
            this.$refs.button.$el.click();
        }
    },
    deactivated() {
        this.data = {};
    }
}
</script>

<style scoped>
div.login {
    background-image: url(../assets/bg-login.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

@media screen and (max-width: 767px) {
    .login .d-flex {
        width: 80%;
    }
}

.btn-giftaway {
    color: #fff;
    display: block;
    margin-top: 10px;
    background: #6dcef5;
    border: #000;
    font-weight: 600;
    letter-spacing: 0.2px;
}
</style>